/**
 * Browser-Telemetrie (Grafana Faro) der Filament-Panels: Exceptions,
 * console.warn/error, Web Vitals, Views und Spans der fetch/XHR-Requests.
 *
 * Die Konfiguration rendert Smake\Support\Filament\Plugins\TelemetryPlugin
 * serverseitig nach window.__smakeTelemetry — nur Ids, die User-Id bereits
 * pseudonymisiert (der Schlüssel bleibt auf dem Server). Ohne Konfiguration
 * (Telemetrie aus) wird dieses Script gar nicht eingebunden.
 *
 * Livewire-Requests sind same-origin: Faro hängt `traceparent` an (nur in
 * gesampelten Sessions), keepsuit setzt den Trace fort — Klick → Livewire →
 * DB/Queue landen in einem Trace. Beacons gehen an /_telemetry/collect, den
 * nginx-Drop-in vor der lokalen Alloy (infra-alloy), PHP sieht sie nie.
 *
 * Redaction: die Default-Regeln des Pakets decken die Token-Routen der Panels
 * (reset-password|activate-account|create-password/<token>) und token=,
 * email=, signature= (signierte Aktivierungs- und Livewire-Upload-URLs) ab,
 * dazu kommen E-Mail-Adressen im Freitext (redactions.js), siehe
 * telemetry.test.js.
 */
import { createTelemetry } from '@smakecloud/browser-telemetry';
import { EXTRA_REDACTIONS } from './redactions.js';

// Websockets und der Broadcasting-Auth-Request bekommen keine Spans.
const IGNORE_URLS = [/pusher|sockjs/, /\/broadcasting\/auth/];

const config = window.__smakeTelemetry;

if (config?.appName) {
    void createTelemetry({
        appName: config.appName,
        collectorUrl: config.collectorUrl,
        environment: config.environment,
        extraRedactions: EXTRA_REDACTIONS,
        ignoreUrls: IGNORE_URLS,
        sampleRate: config.sampleRate,
        sessionAttributes: config.session,
        version: config.version,
    }).then((faro) => {
        if (!faro) {
            return;
        }

        if (config.user) {
            faro.api.setUser(config.user);
        }

        // View = Routenname. Bei wire:navigate (SPA-Modus) rendert Livewire
        // das Konfigurations-Script der neuen Seite erneut in den <head>.
        const setView = () => {
            const name = window.__smakeTelemetry?.view;

            if (name) {
                faro.api.setView({ name });
            }
        };

        setView();
        document.addEventListener('livewire:navigated', setView);
    });
}
